import { render } from "./AddNote.vue?vue&type=template&id=ad4c26e2&scoped=true"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"

import "./AddNote.vue?vue&type=style&index=0&id=ad4c26e2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad4c26e2"]])

export default __exports__